import axios, { AxiosError } from 'axios';
import { redirectOnSessionError } from '../containers/auth/AuthenticationGate';
import { getTenantId } from '../utils/accountHelper';
import { getLocalStorageItem, StorageHelperKeys } from '../utils/storageHelpers';

const grispiApi = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL
});
grispiApi.defaults.headers.post['Content-Type'] = 'application/json';
grispiApi.defaults.headers.put['Content-Type'] = 'application/json';
grispiApi.defaults.headers.patch['Content-Type'] = 'application/json';

grispiApi.interceptors.request.use((req) => {
    req.headers.tenantId = getTenantId();
    ['post', 'put', 'patch'].includes(req?.method?.toLowerCase()) && console.debug(`grispiApi request data`, req?.data);
    return req;
});

type customOriginalRequest = AxiosError['config'] & { retry?: boolean; retryCount?: number };

export const logoutApiURL = `${process.env.NEXT_PUBLIC_BASE_URL}/logout`;

export const isLoggedOut = (): boolean => !!getLocalStorageItem(StorageHelperKeys.LOGGED_OUT);

export const setToken = (token: string) => {
    grispiApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

grispiApi.interceptors.response.use(
    (res) => {
        return res;
    },
    async (error: AxiosError) => {
        if (error?.code === 'ERR_CANCELED') {
            // file upload cancelled by user
            return Promise.reject(error);
        }
        const originalRequest: customOriginalRequest = error.config;
        // const originalRequestURL = `${originalRequest.baseURL}${originalRequest.url}`;

        if (typeof originalRequest === 'undefined') {
            // console.error('grispiApi error', 'originalRequest is not available');
            return Promise.reject(error);
        }

        if (error.response?.status === 401) {
            await redirectOnSessionError();
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

export default grispiApi;
